// extracted by mini-css-extract-plugin
export var addToCartButton = "_jg-b";
export var arrowButtonContainer = "_jg-9";
export var arrowButtonIcon = "_jg-a";
export var carouselArrowButton = "_jg-6";
export var carouselElementContainer = "_jg-1";
export var left = "_jg-7";
export var productDisplayCarouselContainer = "_jg-0";
export var productTileContainer = "_jg-2";
export var productTileImage = "_jg-4";
export var productTileImageContainer = "_jg-3";
export var productTileTitle = "_jg-5";
export var right = "_jg-8";
export var sliderOverflow = "_jg-c";